
import { HttpService } from '../common/http/http.service';
import { User } from '../../../model/user/user.model';
import { Path } from "../../../app.config";
export class LoginService {

    private httpsSrv: HttpService;

    public static $inject: Array<string> = ["HttpService"];
    constructor(httpsService: HttpService) {
        this.httpsSrv = httpsService;
    }


    resetExpiredPassword(existingPassword: string, newPassword: string) {
        var opt = { url: Path.APIUrl.ResetExpiredPasswordUrl(), method: "POST", data: { existingPassword: existingPassword, newPassword: newPassword }};
        return this.httpsSrv.execute(opt);
    }

    resetExpiredPasswordWithSecretQuestion(user:User, newPassword: string) {
        var opt = { url: Path.APIUrl.ResetExpiredPasswordWithSecretQuestionUrl(), method: "POST", data: { user: user, newPassword: newPassword } };
        return this.httpsSrv.execute(opt);
    }
}